import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PRODUCT } from "./data";
import MagicSparkles from "./MagicSparkles";
import { LANDING } from "@/constants/testIds";

// Reusable inline CTA — used after Pain, Method, Deliverables, Bonuses, Testimonials.
// Props: variant ("light" | "dark"), label, sublabel (optional), testId (optional)
export default function InlineCTA({
  variant = "light",
  label = "Quero conhecer a Jornada",
  sublabel = null,
  testId = LANDING.intermediateCta,
  href = PRODUCT.checkoutUrl,
}) {
  const isDark = variant === "dark";
  return (
    <section
      className={`py-14 lg:py-16 ${isDark ? "bg-[#2d1f43]" : "bg-[#f3ecf7]"}`}
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
        {sublabel && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className={`font-body text-[15px] lg:text-base mb-5 ${
              isDark ? "text-[#c4b5fd]" : "text-[#4a3a5e]"
            }`}
          >
            {sublabel}
          </motion.p>
        )}
        <motion.a
          href={href}
          data-testid={testId}
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="group relative btn-shine btn-jelly cta-primary inline-flex"
        >
          <MagicSparkles />
          <span className="relative z-10">{label}</span>
          <ArrowRight className="w-4 h-4 relative z-10 arrow-slide" />
        </motion.a>
      </div>
    </section>
  );
}
